//@ts-ignore
import HotelsDemoNew from "./Hotels";

export default HotelsDemoNew;
